import React from "react";

const PanelExtended = ({children}) => (
    <section className="module">
        {children}
    </section>
);

export const PanelHeader = ({title, children, className}) => {
    return <header className={"module__header " + className}>
        {title && <h2 className="module__title">{title}</h2> || null}
        {children}
    </header>
};

export default PanelExtended;
